import { NgModule } from "@angular/core";
import { Routes, RouterModule, Router, NavigationExtras } from "@angular/router";
import { Shell } from "@shell/shell.service";
import { authGuard } from "@authentication/auth.guard";
import { TipoUsuario } from "@shared/enums/tipoUsuario";
import { FacturacionIndexComponent } from "./facturacion-index/facturacion-index.component";
import { ImportacionPadronesComponent } from "./importacion-padrones/importacion-padrones.component";
import { ComprobanteComponent } from "./reportes/comprobante/comprobante.component";
import { ParametrosImpositivosIndexComponent } from "./parametros-impositivos-v2/parametros-impositivos-index.component";
import { AprobacionRefacturacionComponent } from "./aprobacion-refacturacion/aprobacion-refacturacion.component";
import { CorreccionPreciosComponent } from "./correccion-precios/correccion-precios.component";
import { HoldeoAeroplantaComponent } from "./holdeo/holdeo-aeroplanta/holdeo-aeroplanta.component";
import { HoldeoCuentasComponent } from "./holdeo/holdeo-cuentas/holdeo-cuentas.component";
import { HoldeoAerovalesComponent } from "./holdeo/holdeo-aerovales/holdeo-aerovales.component";
import { RefacturacionIndexComponent } from "./refacturacion-index/refacturacion-index.component";
import { DespachoRefacturacionComponent } from "./despacho-refacturacion/despacho-refacturacion.component";
import { HoldeoPrincipalComponent } from "./holdeo/holdeo-principal/holdeo-principal.component";
import { ReporteFacturasComponent } from "./reportes/reporte-facturas/reporte-facturas.component";
import { RevisionRefacturacionComponent } from "./revision-refacturacion/revision-refacturacion.component";
import { NivelesRefacturacionComponent } from "./niveles-refacturacion/niveles-refacturacion.component";
import { ReporteRemitosVencidosComponent } from "./reportes/reporte-remitos-vencidos/reporte-remitos-vencidos.component";
import { ReportadorRemitosComponent } from "./reportes/reporte-remitos/reportador-remitos/reportador-remitos.component";
import { EjecucionesFacturacionComponent } from "./reportes/ejecuciones/ejecuciones-facturacion/ejecuciones-facturacion.component";
import { ReportesIndexComponent } from "./reportes/reportes-index/reportes-index.component";
import { RefacturacionManualComponent } from "./refacturacion-manual/refacturacion-manual.component";
import { RefacturacionHistorialComponent } from "./refacturacion-historial/refacturacion-historial.component";
import { AuthService } from "@authentication/auth.service";
import { DocumentosIndexComponent } from "./documentos/documentos-index/documentos-index.component";
import { VisorDocumentosComponent } from "./documentos/visor-documentos/visor-documentos.component";
import { CondicionVenta } from "@shared/enums/condicionVenta";
import { ReporteAnticipadoComponent } from "@facturacion/reporte-anticipado/reporte-anticipado.component";
import { TipoSolapaRefacturacion } from "@shared/enums/TipoSolapaRefacturacion";
import { FacturacionService } from "@facturacion/shared/services/facturacion.service";
import { RefacturacionDevolucionLitrosComponent } from "./refacturacion-devolucion-litros/refacturacion-devolucion-litros.component";
import { RemitosListaComponent } from "./Remitos/remitos-lista/remitos-lista.component";
import { HistorialPadronesComponent } from "@facturacion/historial-padrones/historial-padrones.component";

const routes: Routes = [
  Shell.childRoutes([
    { path: 'facturacion/Reportes', redirectTo: 'facturacion/Reportes/reporteRemitos', pathMatch: 'full' },
    { path: 'facturacion/refacturacion', redirectTo: 'facturacion/refacturacion/solicitudRefacturacion', pathMatch: 'full' },
    { path: 'facturacion/holdeoPrincipal', redirectTo: 'facturacion/holdeoPrincipal/holdeoAeroplantas', pathMatch: 'full' },
    { path: 'facturacion/facturacionAnticipada', redirectTo: 'facturacion/facturacionAnticipada/reporteSaldos', pathMatch: 'full' },
    {
      path: 'facturacion', component: FacturacionIndexComponent, canActivate: [authGuard], children: [
{
          path: "parametrosV2",
          component: ParametrosImpositivosIndexComponent,
          canActivate: [authGuard],
        },
        {
          path: "padrones",
          component: ImportacionPadronesComponent,
          canActivate: [authGuard]
        },
        {
          path: "historialPadrones",
          component: HistorialPadronesComponent,
          canActivate: [authGuard]
        },
        {
          path: 'remitos',
          component: RemitosListaComponent,
          canActivate: [authGuard]
        },
        {
          path: 'holdeoPrincipal',
          component: HoldeoPrincipalComponent,
          canActivate: [authGuard],
          children: [
            {
              path: 'holdeoCuentas',
              component: HoldeoCuentasComponent,
              canActivate: [authGuard],
            },
            {
              path: 'holdeoAerovales',
              component: HoldeoAerovalesComponent,
              canActivate: [authGuard],
            },
            {
              path: 'holdeoAeroplantas',
              component: HoldeoAeroplantaComponent,
              canActivate: [authGuard],
            },

          ]
        },
        {
          path: 'refacturacion',
          component: RefacturacionIndexComponent,
          canActivate: [authGuard],
          children: [
            {
              path: 'historialRefacturacion',
              component: RefacturacionHistorialComponent,
              canActivate: [authGuard],
            },
            {
              path: 'solicitudRefacturacion',
              component: RefacturacionManualComponent,
              canActivate: [authGuard],
            },
            {
              path: 'nivelesRefacturacion', component: NivelesRefacturacionComponent,
              canActivate: [authGuard],
            },
            {
              path: 'prerevisionRefacturacion',
              component: RevisionRefacturacionComponent,
              canActivate: [authGuard],
            },
            {
              path: 'revisionRefacturacion',
              component: RevisionRefacturacionComponent,
              canActivate: [authGuard],
            },
            {
              path: 'aprobacionRefacturacion',
              component: AprobacionRefacturacionComponent,
              canActivate: [authGuard],
            },
            {
              path: 'correcionPreciosRefacturacion',
              component: CorreccionPreciosComponent,
              canActivate: [authGuard],
            },
            {
              path: 'despachoRefacturacion',
              component: DespachoRefacturacionComponent,
              canActivate: [authGuard],
            },
            {
              path: 'nivelesRefacturacion',
              component: NivelesRefacturacionComponent,
              canActivate: [authGuard],
            },
            {
              path: 'devolucionLitrosRefacturacion',
              component: RefacturacionDevolucionLitrosComponent,
              canActivate: [authGuard],
            },
          ]
        },
        {
          path: 'reportes', component: ReportesIndexComponent, canActivate: [authGuard], children: [
            // { path: 'Reportes', redirectTo: 'cierreTurno/reporteCierre', pathMatch: 'full' },
            {
              path: 'reporteRemitos',
              component: ReportadorRemitosComponent,
              canActivate: [authGuard]
            },
            {
              path: 'reporteFacturas',
              component: ReporteFacturasComponent,
              canActivate: [authGuard],
            },
            {
              path: 'reporteRemitosVencidos',
              component: ReporteRemitosVencidosComponent,
              canActivate: [authGuard],
            },
            {
              path: 'buscarComprobantes',
              component: ComprobanteComponent,
              canActivate: [authGuard],
            },
            {
              path: 'reporteEjecuciones',
              component: EjecucionesFacturacionComponent,
              canActivate: [authGuard],
            },
            {
              path: 'reporteEjecucionesErrores',
              component: EjecucionesFacturacionComponent,
              canActivate: [authGuard],
            },
          ]
        },
        {
          path: 'documentos', component: DocumentosIndexComponent, canActivate: [authGuard], children:
          [
            {
              path: 'contado',
              component: VisorDocumentosComponent,
              canActivate: [authGuard]
            },
            {
              path: 'ctacte',
              component: VisorDocumentosComponent,
              canActivate: [authGuard],
            },
            {
              path: 'notas',
              component: VisorDocumentosComponent,
              canActivate: [authGuard],
            }
          ]
        },
        {
          path: 'facturacionAnticipada',
          component: ReporteAnticipadoComponent,
          canActivate: [authGuard]
        }
      ]
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class FacturacionRoutingModule {
  constructor( private authService: AuthService, private router: Router, private facturacionService: FacturacionService ) {
    this.router.events.subscribe((event) => {
      if(event['url'] && event['url'] == '/facturacion') {
        this.redireccionarFacturacion();
      }else if(event['url'] && event['url'] == '/facturacion/refacturacion') {
        this.redireccionarRefacturacion();
      }else if(event['url'] && event['url'] == '/facturacion/documentos') {
        this.redireccionarDocumentos();
      }
  });
  }


  redireccionarFacturacion() {
    if(this.authService.hasRole(TipoUsuario.COMERCIAL)){
      this.router.navigate(['/facturacion/refacturacion/correcionPreciosRefacturacion']);
    }else if(this.authService.hasRole(TipoUsuario.RESPRODUCTO)){
      this.router.navigate(['/facturacion/refacturacion/revisionRefacturacion'], {queryParams: {estado: 'revision'}});
    }else if(this.authService.hasRole(TipoUsuario.COMERCIAL_LN, TipoUsuario.COMERCIAL_AV)){
      this.router.navigate(['/facturacion/refacturacion/solicitudRefacturacion'])
    }else if(this.authService.hasRole(TipoUsuario.REFACTURACION)) {
      this.router.navigate(['/facturacion/refacturacion/aprobacionRefacturacion']);
    }else if(this.authService.hasRole(TipoUsuario.IMPUESTOS, TipoUsuario.APROBADORBYR)){
      this.router.navigate(['/facturacion/parametrosV2']);
    }else if(this.authService.hasRole(TipoUsuario.FACTURACION)){
      this.router.navigate(['/facturacion/remitos']);
      //this.router.navigate(['/facturacion/refacturacion/despachoRefacturacion']);
    }else if(this.authService.hasRole(TipoUsuario.OPERADOR_3, TipoUsuario.OPERADORDIRECTO, TipoUsuario.SUPERVISOR, TipoUsuario.TUTOR, TipoUsuario.JEFEDEAEROPLANTA)){
        this.router.navigate(['/facturacion/refacturacion/despachoRefacturacion']);
    }else if(this.authService.hasRole(TipoUsuario.CONSPRECIOS, TipoUsuario.SEGURIDADTABLAS)){
      this.router.navigate(['/facturacion/refacturacion/historialRefacturacion'], {queryParams: { tipo: this.facturacionService.isSeguimientosRefacturacion ? TipoSolapaRefacturacion.SeguimientoRefacturacion : TipoSolapaRefacturacion.HistorialRefacturacion}});
    }else if(this.authService.hasRole(TipoUsuario.OPERADOR, TipoUsuario.MANDATARIO, TipoUsuario.COMERCIAL_AV, TipoUsuario.ADMCLIENTES, TipoUsuario.CONSAEROVALES, TipoUsuario.SOPORTE)){
      this.router.navigate(['/facturacion/reportes']);
    }
  }

  redireccionarRefacturacion() {
    if(this.authService.hasRole(TipoUsuario.COMERCIAL, TipoUsuario.APROBADORBYR)){
      this.router.navigate(['/facturacion/refacturacion/correcionPreciosRefacturacion']);
    }else if(this.authService.hasRole(TipoUsuario.COMERCIAL_LN, TipoUsuario.COMERCIAL_AV)){
      this.router.navigate(['/facturacion/refacturacion/solicitudRefacturacion']);

    }else if(this.authService.hasRole(TipoUsuario.OPERADOR_3, TipoUsuario.OPERADORDIRECTO,TipoUsuario.SUPERVISOR, TipoUsuario.TUTOR, TipoUsuario.COMERCIAL_LN, TipoUsuario.COMERCIAL_AV, TipoUsuario.JEFEDEAEROPLANTA)){
      this.router.navigate(['/facturacion/refacturacion/despachoRefacturacion']);
    }else if(this.authService.hasRole(TipoUsuario.CONSPRECIOS, TipoUsuario.SEGURIDADTABLAS)){
      this.router.navigate(['/facturacion/refacturacion/historialRefacturacion'], {queryParams: { tipo: this.facturacionService.isSeguimientosRefacturacion ? TipoSolapaRefacturacion.SeguimientoRefacturacion : TipoSolapaRefacturacion.HistorialRefacturacion}});
    }else if(this.authService.hasRole(TipoUsuario.FACTURACION, TipoUsuario.RESPRODUCTO)){
      this.router.navigate(['/facturacion/refacturacion/revisionRefacturacion'], {queryParams: {estado: 'revision'}});
    }else if(this.authService.hasRole(TipoUsuario.REFACTURACION)){
      this.router.navigate(['/facturacion/refacturacion/aprobacionRefacturacion'])
    }
  }

  redireccionarDocumentos() {
    const nex: NavigationExtras = {
      queryParams: { notas: false, condicion: CondicionVenta.contado }
    }
    this.router.navigate(['/facturacion/documentos/contado'], nex);
  }
}
